import axios from "axios";

const { CancelToken } = axios;
const getListSource = CancelToken.source();
const getListOfValues = async (apiDomain: string) => {
  try {
    const response = await axios.get(`${apiDomain}/voebiz-utilities/v1/values/list`, {
      cancelToken: getListSource.token,
    });
    const { data } = response;
    return data;
  } catch (error) {
    return { data: [{ lovType: "", dadosEmpresa: [{ id: "", description: "" }] }] };
  }
};

export { getListOfValues, getListSource };
